import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY } from "../../data/content";

const quick = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/why-choose-us", label: "Why Choose Us" },
  { to: "/contact", label: "Contact" },
];

const services = [
  "Horticultural Services",
  "Cleaning Services",
  "Hygiene Solutions",
  "Cleaning & Hygiene Supplies",
  "Facility Support",
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-sml-forest text-white">
    <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16 lg:py-20">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="flex items-center">
            <img src="/logo.png" alt="SML Property Solutions" className="h-20 w-auto rounded-sm bg-white p-1.5" />
          </div>
          <p className="mt-6 text-white/70 text-sm leading-relaxed max-w-xs">
            {COMPANY.tagline}
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {["100% Black-Owned", "Level 1 B-BBEE", "Established 2019"].map((b) => (
              <span key={b} className="font-mono-sml text-[10px] uppercase tracking-[0.16em] border border-white/20 rounded-sm px-2.5 py-1.5 text-white/80">
                {b}
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2">
          <h4 className="font-mono-sml text-[11px] uppercase tracking-[0.2em] text-sml-bronze mb-5">Quick Links</h4>
          <ul className="space-y-3">
            {quick.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-white/70 hover:text-white transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-mono-sml text-[11px] uppercase tracking-[0.2em] text-sml-bronze mb-5">Services</h4>
          <ul className="space-y-3">
            {services.map((s) => (
              <li key={s} className="text-sm text-white/70">{s}</li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-mono-sml text-[11px] uppercase tracking-[0.2em] text-sml-bronze mb-5">Contact</h4>
          <ul className="space-y-4 text-sm">
            <li>
              <a href={COMPANY.phoneHref} data-testid="footer-phone" className="flex items-start gap-3 text-white/80 hover:text-white transition-colors">
                <Phone className="h-4 w-4 mt-0.5 shrink-0 text-sml-bronze" /> {COMPANY.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="flex items-start gap-3 text-white/80 hover:text-white transition-colors break-all">
                <Mail className="h-4 w-4 mt-0.5 shrink-0 text-sml-bronze" /> {COMPANY.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-white/70">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-sml-bronze" /> {COMPANY.address}
            </li>
          </ul>
          <a
            href={COMPANY.productUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-product-link"
            className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-sml-bronze hover:gap-3 transition-all"
          >
            Browse Our Product Range <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/50">© 2026 {COMPANY.legal}. All Rights Reserved.</p>
        <p className="font-mono-sml text-[10px] uppercase tracking-[0.18em] text-white/50">
          Your Environment. Our Responsibility. Excellence in Every Service.
        </p>
      </div>
    </div>
  </footer>
);
